// src/context/ProtectedRoute.js
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // ⏳ attendre que la session charge
  if (loading) {
    return <div style={{ padding:120 }}>Chargement...</div>;
  }

  // ❌ pas connecté → rediriger vers login
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // ✅ connecté → afficher les routes protégées
  return <Outlet />;
}
